export default "__VITE_ASSET__DgsBY2vu__"